import headerAnalytics from 'header.analytics';
import utils from '../shared/utils';

const headerLogo = {};

const config = {
  logoSelector: '.Header3__logo'
};

headerLogo.logInteraction = () => {
  return headerAnalytics.logEvent('header click', ['header', 'logo'].join('>'));
};

headerLogo.getPrivateMethods = () => headerLogo;

headerLogo.init = (_config) => {
  const logoConfig = (_config || config);

  // Patch for hoverintent listening
  utils.addListenerToAll('click', logoConfig.logoSelector, headerLogo.logInteraction);
  utils.addListenerToAll('touchend', logoConfig.logoSelector, headerLogo.logInteraction);
};

headerLogo.config = config;

export default headerLogo;